import React, { useState } from 'react'
import FormItem from '../../components/Form/FormItem';
import '../../index.css';
import '../../App.css';
import FaceBookLogIn from '../../components/Form/FaceBookLogIn'
import GoogleLogIn from '../../components/Form/GoogleLogIn';
import FormButton from '../../components/Form/FormButton';
import api from '../../services/api';

function Formsignup() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    password_confirmation: '',
    firstname: '',
    lastname: '',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({}); // Réinitialiser les erreurs

    // Validation des mots de passe
    if (formData.password !== formData.password_confirmation) {
      setErrors({ ...errors, password_confirmation: "Les mots de passe ne correspondent pas" });
      setIsLoading(false);
      return;
    }

    try {
      // Structure adaptée pour votre API
      const res = await api.post('/signup', {
        email: formData.email,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
        firstname: formData.firstname,
        lastname: formData.lastname
      });

      if (res.status === 200 || res.status === 201) {
        // Stocker le token si renvoyé
        if (res.data.token) {
          localStorage.setItem('auth_token', res.data.token);
        }
        window.location.href = '/dashboard';
      }
    } catch (error) {

      // Gestion spécifique des erreurs
      if (error.response?.data?.validation_errors) {
        setErrors(error.response.data.validation_errors);
      } else if (error.response?.data?.error) {
        setErrors({ general: error.response.data.error });
      } else if (error.response?.data?.message) {
        setErrors({ general: error.response.data.message });
      } else if (error.response?.data) {
        setErrors({ general: 'Erreur lors de l\'inscription' });
      } else {
        setErrors({ general: 'Erreur de connexion au serveur' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
    if (errors.general) {
      setErrors({ ...errors, general: '' });
    }
  };

  return (
    <div className='dark:text-white'>
      <h3 className="text-2xl md:text-3xl font-bold text-dark-1 dark:text-white text-center">S'inscrire</h3>
      <p className="mt-2 text-gray-600 dark:text-gray-300 text-sm md:text-[15px] text-center">
        Vous avez déjà un compte ?
        <a href="/auth/login" className="text-indigo-500 ml-1 hover:underline">Connectez-vous</a>
      </p>

      {errors.general && (
        <div className="mt-3 p-2 bg-red-100 border border-red-400 text-red-700 rounded text-sm">
          {errors.general}
        </div>
      )}

      <form onSubmit={handleSubmit} className='mt-4'>
        <div className='space-y-4'>
          <div>
            <FormItem
              name="Adresse mail"
              type="email"
              inputName="email"
              placeholder="email@exemple.com"
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
            />
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <FormItem
              name="Prénom"
              placeholder="Prénom"
              inputName="firstname"
              value={formData.firstname}
              onChange={handleChange}
              error={errors.firstname}
            />
            <FormItem
              name="Nom"
              placeholder="Nom"
              inputName="lastname"
              value={formData.lastname}
              onChange={handleChange}
              error={errors.lastname}
            />
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <FormItem
              name="Mot de passe"
              placeholder="Mot de passe"
              inputName="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              error={errors.password}
            />
            <FormItem
              name="Confirmer le mot de passe"
              placeholder="Confirmer le mot de passe"
              inputName="password_confirmation"
              type="password"
              value={formData.password_confirmation}
              onChange={handleChange}
              error={errors.password_confirmation}
            />
          </div>
        </div>

        <div className='mt-6'>
          <FormButton
            content={isLoading ? "Inscription..." : "Enregistrer"}
            disabled={isLoading}
          />
        </div>

        <p className='text-center text-dark-1 dark:text-white my-4 text-sm'>
          Ou inscrivez-vous en utilisant
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          <FaceBookLogIn />
          <GoogleLogIn />
        </div>
      </form>
    </div>
  )
}

export default Formsignup;